import { MEDIA_STORAGE_URL_MINIO } from "./constants";

export const getImageURL = (fileName: string) => {
    if (fileName === null) {
        return null;
    }
    return `${MEDIA_STORAGE_URL_MINIO}/roboepics-media/${fileName}`;
};
